export const COOKIE_SETTINGS_MODAL = 'cookieSettings';
